import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac2003',
    ecrans: ['00-2'],
    params: [ '?dhacleint' ]
});

